import React, {useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import { AppShell, Container, Grid, SimpleGrid, Space, Title, Text, Table, Button, Modal, RadioGroup, Radio } from '@mantine/core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faFilePdf, } from '@fortawesome/free-regular-svg-icons'
import { faCar, faTree, faPlane, } from '@fortawesome/free-solid-svg-icons'
import NumberFormat from 'react-number-format';
import { usePDF } from '@react-pdf/renderer';

import { RootState, store } from '../../redux/store';
import { getLocationStatus, getProcessStatus, getOperationStatus, getUtilizationStatus, getCostsStatus, getValueStatus, getPdfStatus, getEqualValues, printCalculation } from '../../redux/calcSlice';
import styles from './App.module.scss';
import Factory from '../Factory';
import CreatePdf from '../../utils/pdfGenerator';
import {locationIcon, prizesIcon, processIcon, utilizationIcon, valueIcon, co2Icon, currencyIcon, operationIcon } from '../../utils/htmlIcons'

import orgTank from '../../assets/images/original-icon.png'
import rplTank from '../../assets/images/replacement-icon.png'
// import orgTank from '../../assets/images/original-icon.svg'
// import rplTank from '../../assets/images/replacement-icon.svg'

const mediumSite = [
  {name: "throughput", value: 3000},
  {name: "recovery", value: 82},
  {name: "cellSize", value: '70'},
  {name: "cellsPerLine", value: 6},
  {name: "linesParallel", value: 2},
  {name: "availability", value: 340},
  {name: "treatmentCharges", value: 3},
  {name: "energyCost", value: 0.07},
  {name: "expectedShift", value: 0.75},
]

const largeSite = [
  {name: "throughput", value: 3200},
  {name: "recovery", value: 84},
  {name: "cellSize", value: '100'},
  {name: "cellsPerLine", value: 10},
  {name: "linesParallel", value: 2},
  {name: "availability", value: 344},
  {name: "treatmentCharges", value: 4},
  {name: "energyCost", value: 0.07},
  {name: "expectedShift", value: 0.75},
]

const xlSite = [
  {name: "throughput", value: 3800},
  {name: "recovery", value: 88},
  {name: "cellSize", value: '200'},
  {name: "cellsPerLine", value: 8},
  {name: "linesParallel", value: 3},
  {name: "availability", value: 350},
  {name: "treatmentCharges", value: 4.5},
  {name: "energyCost", value: 0.07},
  {name: "expectedShift", value: 0.75},
]


function App() {
  const [instance, updateInstance] = usePDF({ document: <CreatePdf data={{...useSelector(printCalculation()),...useSelector(getEqualValues())}} />})
  const [activeGrid, setActiveGrid] = useState('location')
  const [downloadPdf, setDownloadPdf] = useState(false)
  // const [wizardVisibility, setWizardVisibility] = useState(true)

  const equalValues = useSelector(getEqualValues())  
  const cellRows = useSelector( (state:RootState) => state.calc.linesParallel.value )
  const cellsInRow = useSelector( (state:RootState) => state.calc.cellsPerLine.value )
  const replacedCellsInRow = useSelector( (state:RootState) => state.calc.proposedNumCellsInLine.value )

  const divider = (equalValues.trees > 10000) ?1000 :100

  const createIconSet = (value:string,  multiPlier:number, icon:any) => {
    if(!equalValues || !equalValues[value]) return 
    const numberOfIcons = Math.round(equalValues[value]/multiPlier)
    const retVal = []
    for(var i=0;i<numberOfIcons;i++) {
      retVal.push(<FontAwesomeIcon icon={icon} size="2x" style={{marginRight:'4px'}} key={i} />)
    }

    return retVal
  }

  const createOriginalRows = () => {
    const oneRow = []

    if(cellsInRow>12 || cellRows>12) return

    for(var i=0;i<cellsInRow;i++) {
      oneRow.push(<img src={orgTank} className={styles.tankIcon} style={{marginTop:(Math.floor(i/2)*3)+'px'}} key={i} />)
      // oneRow.push(<FontAwesomeIcon icon={faCar} size="sm" style={{marginRight:'4px'}} />)
    }

    const retVal = []
    for(var i=0;i<cellRows;i++) {
      retVal.push(<div style={{display:'flex', flexDirection:'row', alignItems:'flex-start'}} key={i}>{oneRow}</div>)
    }

    return retVal
  }

  const createReplacementRows = () => {
    const oneRow = []

    if(cellsInRow>12 || cellRows>12) return

    for(var i=0;i<(cellsInRow-replacedCellsInRow);i++) {
      oneRow.push(<img src={orgTank} className={styles.tankIcon} style={{marginTop:(Math.floor(i/2)*3)+'px'}}  key={i} />)
    }
    for(var i=0;i<replacedCellsInRow;i++) {
      oneRow.push(<img src={rplTank} className={styles.tankIcon} style={{marginTop:(Math.floor((i+(cellsInRow-replacedCellsInRow))/2)*3)+'px'}} key={i+(cellsInRow-replacedCellsInRow)}/>)
    }

    const retVal = []
    for(var i=0;i<cellRows;i++) {
      retVal.push(<div style={{display:'flex', flexDirection:'row', alignItems:'flex-start'}} key={i}>{oneRow}</div>)
    }

    return retVal
  }


  useEffect( ()=>{

    if(downloadPdf && instance && !instance.loading) {
      const url:string = instance.url || ''
      // window.open(url,'_blank')
      const link = document.createElement('a')
      link.setAttribute('href', url)
      link.setAttribute('target', 'blank')
      link.setAttribute('download', 'Metso_froth.pdf')
      link.click()
      window.URL.revokeObjectURL(url)
      setDownloadPdf(false)
    }

  },[downloadPdf,instance])

  const onDownloadPdf = () => {
    updateInstance()
    setDownloadPdf(true)    
  }

  const onSetPreset = (selectedSite:any) => {

    for(var i=0; i < selectedSite.length; i++) {
      store.dispatch({type:'calc/setValue', payload:{name: selectedSite[i].name, value: selectedSite[i].value }})
    }

  }

  return (
    <AppShell className={styles.App} >

{/*       <Modal
        className={styles.App} 
        opened={wizardVisibility}
        onClose={ () => setWizardVisibility(false)} 
        closeOnClickOutside={false}
        closeOnEscape={false}
        hideCloseButton={true}
        size="70%"
        centered >

          <Text className={styles.modalTitle}>Value & sustainability calculator for Froth Management solution</Text>
          <Text className={styles.ingress}>Please fill in the fields below before getting started</Text>

          <div className={styles.modalInputFields}>
            <Factory property="location" renderer="Modal" />
            <Factory property="material" renderer="Modal" />
            <Factory property="headGrade" renderer="Modal" />
            <div className={styles.modalInputLine}>
              <div className={styles.modalInputTitle}>
                Size class of the site
              </div>
              <RadioGroup className={styles.modalInputField}>
                <Radio className={styles.modalRadio} onClick={() => onSetPreset(mediumSite) } value="medium">Medium site</Radio>
                <Radio className={styles.modalRadio} onClick={() => onSetPreset(largeSite) } value="large">Large site</Radio>
                <Radio className={styles.modalRadio} onClick={() => onSetPreset(xlSite) } value="extralarge">XL site</Radio>
              </RadioGroup>
            </div>
          </div>

          <div className={styles.modalButtons}>
            <Button
              // disabled={ useSelector( getPdfStatus()) } 
              styles={(theme) => ({
                root: {
                  width: '200px',
                  minHeight: '58px',
                  backgroundColor: '#00e2b2',
                  border: 'none',
                  color: '#333',
                  fontSize: '1.1rem',
                  padding: '10px 23px',
                  'svg':{
                    color:'#000',
                    height:'26px',
                  },
                  '&:hover': {
                    backgroundColor: theme.fn.darken('#090909', 0.05),
                    color: '#fff',
                    'svg':{
                      color:'#fff',
                      height:'26px',
                    }
                  },
                },          
              })}
              onClick={()=>setWizardVisibility(false) }>
                { useSelector( getPdfStatus())
                 ? 'Skip'
                 : 'Get started'
                }
                </Button>

            
          </div>

      </Modal> */}

      <Container className={styles.container}>
        {/* <Title order={1}>Value Calculator for Froth Management solution</Title> */}
        <Title order={1}>Value & sustainability calculator for Froth Management solution</Title>
        <Title order={2}>&mdash; Calculate your savings and get the results in PDF</Title>
        <Text className={styles.ingress}>
          By filling in the fields below with as much information as possible, you will see the economical and environmental benefits you could achieve with the Flotation Management
          solution in your flotation process.  Please note, the default values in the calculator (i.e. metal prices) are updated periodically and may not be completely accurate at the
          time of your calculation.  For any additional information or inquiries, please contact your local Metso representative or use the enclosed contact request and we will
          respond as soon as possible!
        </Text>
      </Container>

      <Container className={styles.container}>
        <Grid gutter={'xs'}>
          <Grid.Col lg={ activeGrid === 'location' ?12 :4} md={ activeGrid === 'location' ?12 :6} onClick={e => setActiveGrid('location')}>
            <div className={useSelector(getLocationStatus()) ?(activeGrid === 'location' ?styles.gridItem :styles.gridItemReadyClosed) :styles.gridItemNotReady}>
              <div className={styles.gridItemHeader}>
                <div className={styles.gridItemHeaderIcon} >
                  {locationIcon(60,60,'#000000')}
                </div>
                <div className={styles.gridItemHeaderLabel}>
                  <Title order={3} className={activeGrid === 'location' ?styles.gridItemActive :''}>Location</Title>
                  {activeGrid !== 'location' &&
                    <Factory property="location" renderer="MainInput" />
                  }
                </div>
              </div>
              { activeGrid === 'location'
                && (
                  <SimpleGrid cols={2} breakpoints={[{ maxWidth: 755, cols: 1 },]}>
                    <Factory property="location" />
                  </SimpleGrid>
                  )
              }
            </div>
          </Grid.Col>
          <Grid.Col lg={ activeGrid === 'process' ?12 :4} md={ activeGrid === 'process' ?12 :6} onClick={e => setActiveGrid('process')} >
            <div className={useSelector(getProcessStatus()) ?(activeGrid === 'process' ?styles.gridItem :styles.gridItemReadyClosed) :styles.gridItemNotReady}>
              <div className={styles.gridItemHeader}>
                <div className={styles.gridItemHeaderIcon} >
                  {processIcon(60,60,'#000000')}
                </div>
                <div className={styles.gridItemHeaderLabel}>
                  <Title order={3} className={activeGrid === 'process' ?styles.gridItemActive :''}>Process specifications</Title>
                  {activeGrid !== 'process' &&
                    <Factory property="material" renderer="MainInput"/>
                  }
                </div>
              </div>
              { activeGrid === 'process'
                && (
                  <>
                    <SimpleGrid cols={2} breakpoints={[{ maxWidth: 755, cols: 1 },]}>
                      <div>
                        <Factory property="material" />
                        <Factory property="throughput" />
                        <Factory property="headGrade" />
                        <Factory property="recovery" />

                      </div>
                      <div>
                        <Factory property="recoveryPerY" decimals={0}/>
                      </div>
                    </SimpleGrid>
                  </>

                )
              }
            </div>
          </Grid.Col>
          <Grid.Col lg={ activeGrid === 'operation' ?12 :4} md={ activeGrid === 'operation' ?12 :6} onClick={e => setActiveGrid('operation')} >
            <div className={useSelector(getOperationStatus()) ?(activeGrid === 'operation' ?styles.gridItem :styles.gridItemReadyClosed) :styles.gridItemNotReady}>
              <div className={styles.gridItemHeader}>
                <div className={styles.gridItemHeaderIcon} >
                  {operationIcon(60,60,'#000000')}
                </div>
                <div className={styles.gridItemHeaderLabel}>
                  <Title order={3} className={activeGrid === 'operation' ?styles.gridItemActive :''}>Roughers and rougher-scavengers{activeGrid !== 'operation' ?' - Tank volume' :''}</Title>
                  {activeGrid !== 'operation' &&
                    <Factory property="cellSize" renderer="MainInput"/>
                  }
                </div>
              </div>
              { activeGrid === 'operation'
                && (
                  <>
                    <SimpleGrid cols={2} breakpoints={[{ maxWidth: 755, cols: 1 },]}>
                      <div>
                        <Factory property="launderType" renderer="Radio" />
                        <Factory property="cellSize" />
                        <Factory property="cellsPerLine" />
                        <Factory property="linesParallel" />
                      </div>
                      <div>
                        <Factory property="cellsInCircuit" />
                        <Factory property="proposedNumCellsInLine" />
                        <Factory property="proposedNumCellsTotal" />
                        <Factory property="blowerPowerBefore" decimals={0}/>
                      </div>
                    </SimpleGrid>
                    <SimpleGrid cols={2} breakpoints={[{ maxWidth: 755, cols: 1 },]}>
                      <div className={styles.originalTanks}>
                        <Title order={4}>Before upgrade</Title>
                        {(cellRows && cellsInRow)
                          ? createOriginalRows()
                          : '-'
                        }
                      </div>
                      <div className={styles.replacementTanks}>
                      </div>
                    </SimpleGrid>
                  </>
                )
              }
            </div>
          </Grid.Col>
          <Grid.Col lg={ activeGrid === 'utilization' ?12 :4} md={ activeGrid === 'utilization' ?12 :6} onClick={e => setActiveGrid('utilization')} >
            <div className={useSelector(getUtilizationStatus()) ?(activeGrid === 'utilization' ?styles.gridItem :styles.gridItemReadyClosed) :styles.gridItemNotReady}>
              <div className={styles.gridItemHeader}>
                <div className={styles.gridItemHeaderIcon} >
                  {utilizationIcon(60,60,'#000000')}
                </div>
                <div className={styles.gridItemHeaderLabel}>
                  <Title order={3} className={activeGrid === 'utilization' ?styles.gridItemActive :''}>Utilization</Title>
                  {activeGrid !== 'utilization' &&
                    <Factory property="availability" renderer="MainInput"/>
                  }
                </div>
              </div>
              { activeGrid === 'utilization'
                && (
                  <>
                    <SimpleGrid cols={2} breakpoints={[{ maxWidth: 755, cols: 1 },]} >
                      <div>
                        <Factory property="availability" />
                      </div>
                      <div>
                        <Factory property="availabilityPercent" />
                        <Factory property="opTime" decimals={0}/>
                      </div>
                    </SimpleGrid>
                  </>
                )
              }
            </div>
          </Grid.Col>
          <Grid.Col lg={ activeGrid === 'costs' ?12 :4} md={ activeGrid === 'costs' ?12 :6} onClick={e => setActiveGrid('costs')} >
            <div className={useSelector(getCostsStatus()) ?(activeGrid === 'costs' ?styles.gridItem :styles.gridItemReadyClosed) :styles.gridItemNotReady}>
              <div className={styles.gridItemHeader}>
                <div className={styles.gridItemHeaderIcon} >
                  {prizesIcon(60,60,'#000000')}
                </div>
                <div className={styles.gridItemHeaderLabel}>
                  <Title order={3} className={activeGrid === 'costs' ?styles.gridItemActive :''}>Price & Costs</Title>
                  {activeGrid !== 'costs' &&
                    <Factory property="materialPrize" renderer="MainInput"/>
                  }
                </div>
              </div>
              { activeGrid === 'costs'
                && (
                  <>
                    <SimpleGrid cols={2} breakpoints={[{ maxWidth: 755, cols: 1 },]}>
                      <div>
                        <Factory property="materialPrize" />
                        <Factory property="treatmentCharges" />
                        <Factory property="concentratorPower" />
                        <Factory property="energyCost" />
                      </div>
                    </SimpleGrid>
                  </>
                )
              }
            </div>
          </Grid.Col>
          <Grid.Col lg={ activeGrid === 'value' ?12 :4} md={ activeGrid === 'value' ?12 :6} onClick={e => setActiveGrid('value')} >
            <div className={useSelector(getValueStatus()) ?(activeGrid === 'value' ?styles.gridItem :styles.gridItemReadyClosed) :styles.gridItemNotReady}>
              <div className={styles.gridItemHeader}>
                <div className={styles.gridItemHeaderIcon} >
                  {valueIcon(60,60,'#000000')}
                </div>
                <div className={styles.gridItemHeaderLabel}>
                  <Title order={3} className={activeGrid === 'value' ?styles.gridItemActive :''}>Value proposition & Solution</Title>
                  {activeGrid !== 'value' &&
                    <Factory property="expectedShift" renderer="MainInput"/>
                  }
                </div>
              </div>
              { activeGrid === 'value'
                && (
                  <>
                    <SimpleGrid cols={2} breakpoints={[{ maxWidth: 755, cols: 1 },]}>
                      <div>
                        <Factory property="expectedShift" />
                      </div>
                      <div>
                        <Factory property="newRecovery" decimals={4} />
                        <Factory property="newRecoveryPerY" decimals={0}/>
                        <Factory property="newExtraRecovery" decimals={0}/>
                      </div>
                    </SimpleGrid>
                    <SimpleGrid cols={2} breakpoints={[{ maxWidth: 755, cols: 1 },]}>
                      <div className={styles.originalTanks}>
                      </div>
                      <div className={styles.replacementTanks}>
                        {(cellRows && cellsInRow && replacedCellsInRow)
                          ?<>
                            <Title order={4}>Upgraded existing cells with Metso froth management</Title>
                            {createReplacementRows()}
                            <Title order={4}>Green cells upgraded</Title>
                           </>
                          : ''
                        }
                      </div>
                    </SimpleGrid>
                  </>
                )
              }
            </div>
          </Grid.Col>
        </Grid>

        <Text className={styles.heading} >Economical and environmental benefits</Text>
        <Grid gutter={'xs'} className={styles.benefits}>
          <Grid.Col md={6} sm={12} >
            <div className={styles.benefitsItem}>
              <div className={styles.benefitsIcon}>
                {currencyIcon(80,80,'#ffffff')}
              </div>
              <div className={styles.benefitsResult}>
                <Factory property="cashIncrease" renderer="Benefits"/>
              </div>
            </div>
          </Grid.Col>

          <Grid.Col md={6} sm={12} >
            <div className={styles.benefitsItem}>
              <div className={styles.benefitsIcon}>
                {co2Icon(80,80,'#ffffff')}
              </div>
              <div className={styles.benefitsResult}>
                <Factory property="co2TotalSavedAnnual" renderer="Benefits" prefix="negation"/>
              </div>
            </div>
          </Grid.Col>

        </Grid>
        <Text className={styles.heading} > CO{String.fromCharCode(8322)}e reduction equals to</Text>
        <Grid gutter={'xs'} style={!equalValues.cars ?{display:'none'} :{}}>
{/*           <Grid.Col lg={4} md={6} sm={12} >
            <div className={styles.equalsItem}>
              <div className={styles.equalsIcon}>
                <div className={styles.equalsIconset} style={{color:'#e5097c'}}>
                  {
                    createIconSet('cars',10,faCar)
                  }
                </div>
                <div className={styles.equalsMultiplier}>x 10</div>
              </div>
              <div className={styles.equalsResult}>
                <Text className={styles.equalsResultsNumber}><NumberFormat value={equalValues.cars ?Math.round(equalValues.cars) :'-'} displayType={'text'} decimalScale={0}/></Text>
                <Text className={styles.equalsResultsLabel}>Cars removed from the streets</Text>
              </div>
            </div>
          </Grid.Col> */}
          <Grid.Col md={6} sm={12} >
            <div className={styles.equalsItem}>
              <div className={styles.equalsIcon}>
                <div className={styles.equalsIconset} style={{color:'#51d645'}}>
                  {
                    (cellRows<=12 && cellsInRow<=12) &&
                      createIconSet('trees',divider,faTree)
                  }
                </div>
                <div className={styles.equalsMultiplier}>x {divider}</div>
              </div>
              <div className={styles.equalsResult}>
                <Text className={styles.equalsResultsNumber}><NumberFormat value={equalValues.trees ?Math.round(equalValues.trees) :'-'} displayType={'text'} decimalScale={0}/></Text>
                <Text className={styles.equalsResultsLabel}>Planted trees</Text>
              </div>
            </div>
          </Grid.Col>
{/*           <Grid.Col lg={4} md={6} sm={12} >
            <div className={styles.equalsItem}>
              <div className={styles.equalsIcon}>
                <div className={styles.equalsIconset} style={{color:'#4e2098'}}>
                  {
                    createIconSet('planes',100,faPlane)
                  }
                </div>
                <div className={styles.equalsMultiplier}>x 100</div>
              </div>
              <div className={styles.equalsResult}>
                <Text className={styles.equalsResultsNumber}><NumberFormat value={equalValues.planes ?Math.round(equalValues.planes) :'-'} displayType={'text'} decimalScale={0}/></Text>
                <Text className={styles.equalsResultsLabel}>Air miles</Text>
              </div>
            </div>
          </Grid.Col> */}
        </Grid>

        <Text className={styles.heading} >Summary</Text>
        <Table verticalSpacing="xs" className={styles.finalResults}>
          <thead>
            <tr className={styles.tableHeader}>
              <th></th>
              <th>Upgrade</th>
            </tr>
          </thead>
          <tbody>
            <Factory property="newRecoveryPerY" renderer="Table" decimals={0} />
            <Factory property="extraTonnesAnnual" renderer="Table" decimals={0} />
            <Factory property="powerTotalSavedAnnual" renderer="Table" decimals={0}/>
            <Factory property="co2TotalSavedAnnual" renderer="Table" decimals={0}/>
            <Factory property="co2FootPrint" renderer="Table" decimals={0}/>
            <Factory property="co2Payback" renderer="Table"/>

            <tr>
              <td colSpan={2} className={styles.tableSubHeaderCell}>
                <Text className={styles.tableSubHeader} >Blower</Text>
              </td>
            </tr>
            <Factory property="blowerPowerSavedAnnual" renderer="Table" decimals={0} />
            <Factory property="blowerCO2SavedAnnual" renderer="Table" decimals={0} />


            <tr>
              <td colSpan={2} className={styles.tableSubHeaderCell}>
                <Text className={styles.tableSubHeader} >Extra recovery</Text>
              </td>
            </tr>

            <Factory property="powerSavedAnnualMwh" renderer="Table" decimals={0} />
            <Factory property="co2SavedAnnual" renderer="Table" decimals={0}/>
          </tbody>
        </Table>
        
        <div className={styles.printPdf} >
          <Text className={styles.heading} >Download in PDF and learn more about references and Froth Management</Text>
          <Button radius={0} uppercase leftIcon={<FontAwesomeIcon icon={faFilePdf} size="lg" color="#fff" />}
            disabled={ useSelector( getPdfStatus()) } 
            styles={(theme) => ({
              root: {
                width: '280px',
                minHeight: '58px',
                backgroundColor: '#EB2814',
                border: 'none',
                color: '#fff',
                fontSize: '1.1rem',
                padding: '10px 23px',
                'svg':{
                  color:'#fff',
                  height:'26px',
                },
                '&:hover': {
                  backgroundColor: theme.fn.darken('#090909', 0.05),
                  color: '#fff',
                  'svg':{
                    color:'#fff',
                    height:'26px',
                  }
                },
              },
          
              leftIcon: {
                marginRight: 45,
              },
            })} onClick={(e:any) => onDownloadPdf()}> 
            Download result
          </Button>
        </div>

        <div className={styles.footerText}>
          All values and figures seen in the below value calculator are intended for information purposes only and cannot be taken as a guarantee or binding to Metso in any way. Currency and market fluctuations
          will not be updated in real time; economic gain and environmental benefits are only to be seen as indicative to our clientele. The CO{String.fromCharCode(8322)}e (i.e. global warming potential in kg of CO2 equivalents) savings are
          estimated with an LCA approach and based only on the decreased electricity consumption (i.e. decreased country-specific emissions of consumed electricity).
                
        </div>

      </Container>

    </AppShell>
  );
}

export default App;